import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Static inquiries data for guest mode
const staticInquiries = [
  {
    id: 1,
    text: "لماذا تظهر السماء باللون الأزرق خلال اليوم ولكن تتحول إلى اللون الأحمر والبرتقالي عند غروب الشمس؟",
    user_name: "أحمد محمد",
    user_image: "https://randomuser.me/api/portraits/men/32.jpg",
    date: "27 Jan, 2024"
  },
  {
    id: 2,
    text: "كيف تعمل الخلايا الشمسية في تحويل ضوء الشمس إلى طاقة كهربائية؟",
    user_name: "سارة أحمد",
    user_image: "https://randomuser.me/api/portraits/women/44.jpg",
    date: "26 Jan, 2024"
  },
  {
    id: 3,
    text: "ما هو الفرق بين التكاثر الجنسي والتكاثر اللاجنسي في الكائنات الحية؟",
    user_name: "محمد علي",
    user_image: "https://randomuser.me/api/portraits/men/67.jpg",
    date: "25 Jan, 2024"
  },
  {
    id: 4,
    text: "كيف يمكن حساب مساحة المثلث باستخدام قاعدة وارتفاع؟",
    user_name: "فاطمة حسن",
    user_image: "https://randomuser.me/api/portraits/women/23.jpg",
    date: "24 Jan, 2024"
  },
  {
    id: 5,
    text: "ما هي العوامل المؤثرة على سرعة التفاعل الكيميائي؟",
    user_name: "علي محمد",
    user_image: "https://randomuser.me/api/portraits/men/89.jpg",
    date: "23 Jan, 2024"
  },
  {
    id: 6,
    text: "كيف تختلف الخصائص الفيزيائية للماء عن باقي السوائل؟",
    user_name: "نورا أحمد",
    user_image: "https://randomuser.me/api/portraits/women/56.jpg",
    date: "22 Jan, 2024"
  },
  {
    id: 7,
    text: "ما هو دور الميتوكوندريا في الخلية؟",
    user_name: "ليلى أحمد",
    user_image: "https://randomuser.me/api/portraits/women/78.jpg",
    date: "21 Jan, 2024"
  },
  {
    id: 8,
    text: "كيف يتم حساب الجذر التربيعي بدون آلة حاسبة؟",
    user_name: "حسن محمد",
    user_image: "https://randomuser.me/api/portraits/men/45.jpg",
    date: "20 Jan, 2024"
  },
  {
    id: 9,
    text: "ما هي أنواع الروابط الكيميائية؟",
    user_name: "مريم علي",
    user_image: "https://randomuser.me/api/portraits/women/34.jpg",
    date: "19 Jan, 2024"
  }
];

// Async thunk for fetching inquiries
export const fetchInquiries = createAsyncThunk(
  "inquiries/fetchInquiries",
  async ({ page = 1, limit = 6 } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        // Return static data if no token
        return {
          inquiries: staticInquiries.slice(0, limit),
          pagination: {
            total: staticInquiries.length,
            per_page: limit,
            current_page: page,
            last_page: Math.ceil(staticInquiries.length / limit),
            pages_count: Math.ceil(staticInquiries.length / limit)
          }
        };
      }

      const response = await fetch(`${BASE_URL}/inquiries/get_inqueries?page=${page}&limit=${limit}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          inquiries: staticInquiries.slice(0, limit),
          pagination: {
            total: staticInquiries.length,
            per_page: limit,
            current_page: page,
            last_page: Math.ceil(staticInquiries.length / limit),
            pages_count: Math.ceil(staticInquiries.length / limit)
          }
        };
      }

      // Handle the API response structure
      let inquiriesData = [];
      let paginationData = {};

      if (data.result && data.result.data) {
        inquiriesData = data.result.data;
        paginationData = data.result.pagination || {};
      } else if (data.result) {
        inquiriesData = data.result;
        paginationData = data.pagination || {};
      } else {
        inquiriesData = staticInquiries.slice(0, limit);
        paginationData = {
          total: staticInquiries.length,
          per_page: limit,
          current_page: page,
          last_page: Math.ceil(staticInquiries.length / limit),
          pages_count: Math.ceil(staticInquiries.length / limit)
        };
      }

      // Ensure pagination has both last_page and pages_count
      if (paginationData.last_page && !paginationData.pages_count) {
        paginationData.pages_count = paginationData.last_page;
      }
      if (paginationData.pages_count && !paginationData.last_page) {
        paginationData.last_page = paginationData.pages_count;
      }


      return {
        inquiries: Array.isArray(inquiriesData) ? inquiriesData : staticInquiries.slice(0, limit),
        pagination: paginationData
      };
    } catch (error) {
      console.error('Error fetching inquiries:', error);
      return {
        inquiries: staticInquiries.slice(0, limit),
        pagination: {
          total: staticInquiries.length,
          per_page: limit,
          current_page: page,
          last_page: Math.ceil(staticInquiries.length / limit),
          pages_count: Math.ceil(staticInquiries.length / limit)
        }
      };
    }
  }
);

// Async thunk for asking a new question
export const askInquiry = createAsyncThunk(
  "inquiries/askInquiry",
  async ({ text }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await fetch(`${BASE_URL}/inquiries/ask_inquery`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ text }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to ask question");
      }

      return data;
    } catch (error) {
      console.error('Error asking inquiry:', error);
      return rejectWithValue(error.message || "Failed to ask question");
    }
  }
);

// Async thunk for answering an inquiry
export const answerInquiry = createAsyncThunk(
  "inquiries/answerInquiry",
  async ({ inquiryId, text }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await fetch(`${BASE_URL}/inquiries/answer_inquery/${inquiryId}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ answer: text }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to answer question");
      }

      return data;
    } catch (error) {
      console.error('Error answering inquiry:', error);
      return rejectWithValue(error.message || "Failed to answer question");
    }
  }
);

// Async thunk for fetching inquiry answers
export const fetchInquiryAnswers = createAsyncThunk(
  "inquiries/fetchInquiryAnswers",
  async ({ inquiryId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await fetch(`${BASE_URL}/inquiries/inquery_answers/${inquiryId}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "Failed to fetch answers");
      }

      // Handle the API response structure correctly
      let answersData = [];
      if (data.result && data.result.data) {
        answersData = data.result.data;
      } else if (data.result) {
        answersData = data.result;
      } else {
        answersData = data;
      }

      return { inquiryId, answers: Array.isArray(answersData) ? answersData : [] };
    } catch (error) {
      console.error('Error fetching inquiry answers:', error);
      return rejectWithValue(error.message || "Failed to fetch answers");
    }
  }
);

const initialState = {
  inquiries: [],
  loading: false,
  error: null,
  pagination: null,
  currentPage: 1,
  askingInquiry: false,
  answeringInquiry: false,
  fetchingAnswers: false,
  inquiryAnswers: {},
  askInquiryError: null,
  answerInquiryError: null,
};

const inquiriesSlice = createSlice({
  name: "inquiries",
  initialState,
  reducers: {
    clearInquiriesError: (state) => {
      state.error = null;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearAskInquiryError: (state) => {
      state.askInquiryError = null;
    },
    clearAnswerInquiryError: (state) => {
      state.answerInquiryError = null;
    },
    clearInquiryAnswers: (state) => {
      state.inquiryAnswers = {};
    },
    addAnswerToInquiry: (state, action) => {
      const { inquiryId, answer } = action.payload;
      if (!state.inquiryAnswers[inquiryId]) {
        state.inquiryAnswers[inquiryId] = [];
      }
      state.inquiryAnswers[inquiryId].push(answer);
    },
    addInquiry: (state, action) => {
      const { inquiry } = action.payload;
      state.inquiries.unshift(inquiry); // Add to the beginning
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Inquiries
      .addCase(fetchInquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.inquiries = action.payload.inquiries;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchInquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Ask Inquiry
      .addCase(askInquiry.pending, (state) => {
        state.askingInquiry = true;
        state.askInquiryError = null;
      })
      .addCase(askInquiry.fulfilled, (state, action) => {
        state.askingInquiry = false;
        // Optionally refresh the inquiries list
        // You can dispatch fetchInquiries here if needed
      })
      .addCase(askInquiry.rejected, (state, action) => {
        state.askingInquiry = false;
        state.askInquiryError = action.payload;
      })
      // Answer Inquiry
      .addCase(answerInquiry.pending, (state) => {
        state.answeringInquiry = true;
        state.answerInquiryError = null;
      })
      .addCase(answerInquiry.fulfilled, (state, action) => {
        state.answeringInquiry = false;
        // Clear any previous errors
        state.answerInquiryError = null;
        
        // Add the new answer to the state immediately
        if (action.payload && action.payload.result) {
          const newAnswer = action.payload.result;
          // Find the inquiry ID from the payload or use a different approach
          // For now, we'll need to get the inquiryId from the action meta
        }
      })
      .addCase(answerInquiry.rejected, (state, action) => {
        state.answeringInquiry = false;
        state.answerInquiryError = action.payload;
      })
      // Fetch Inquiry Answers
      .addCase(fetchInquiryAnswers.pending, (state) => {
        state.fetchingAnswers = true;
      })
      .addCase(fetchInquiryAnswers.fulfilled, (state, action) => {
        state.fetchingAnswers = false;
        state.inquiryAnswers[action.payload.inquiryId] = action.payload.answers;
      })
      .addCase(fetchInquiryAnswers.rejected, (state, action) => {
        state.fetchingAnswers = false;
        // Handle error if needed
      });
  },
});

export const { 
  clearInquiriesError, 
  setCurrentPage, 
  clearAskInquiryError, 
  clearAnswerInquiryError, 
  clearInquiryAnswers,
  addAnswerToInquiry,
  addInquiry
} = inquiriesSlice.actions;
export default inquiriesSlice.reducer; 